export const UMB_ELEMENT_RECYCLE_BIN_ROOT_ENTITY_TYPE = 'element-recycle-bin-root';
